import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ModalController, IonicModule } from '@ionic/angular';
import _ from 'lodash';

import { ExternalCrmAccount } from 'src/models';

import { ExternalCrmAccountSelectorModalComponent } from './external-crm-account-selector-modal/external-crm-account-selector-modal.component';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule],
  selector: 'app-external-crm-account-selector',
  templateUrl: './external-crm-account-selector.component.html',
  styleUrls: ['./external-crm-account-selector.component.css'],
})
export class ExternalCrmAccountSelectorComponent {
  @Input() externalCrmAccount?: ExternalCrmAccount;
  @Input() externalCrmType: string;

  @Output() externalCrmAccountDidChange = new EventEmitter<ExternalCrmAccount>();

  constructor(private modalCtrl: ModalController) {}

  async openModal() {
    const modal = await this.modalCtrl.create({
      component: ExternalCrmAccountSelectorModalComponent,
      componentProps: {
        selectedExternalCrmAccount: this.externalCrmAccount,
        externalCrmType: this.externalCrmType,
      },
    });

    modal.present();

    modal.onDidDismiss().then(({ data }: any) => {
      if (data?.externalCrmAccount) {
        this.setExternalCrmAccount(data.externalCrmAccount);
      }
    });
  }

  clear() {
    this.setExternalCrmAccount(undefined);
  }

  setExternalCrmAccount(externalCrmAccount?: ExternalCrmAccount) {
    this.externalCrmAccount = externalCrmAccount;
    this.externalCrmAccountDidChange.emit(this.externalCrmAccount);
  }
}
